import {Point} from 'pixi.js';
import {inject} from 'inversify';
import {StickyRichLabelData, WaterMarkView} from '@gongxigames/framework/slot/modules/watermark';
import {WaterMarkComponentsConfigLandscape} from '@gongxigames/framework/slot/modules/watermark/components/WaterMarkComponentsConfig';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {CoreDI, DeviceType, ObjectBuilder, ScreenManager} from '@gongxigames/framework/core';

export class WaterMarkViewMobileLandscape extends WaterMarkView {

    @inject(CoreDI. ScreenManager)
    protected screenManager!: ScreenManager;

    public static readonly NAME: symbol = Symbol('WaterMarkViewMobileLandscape');
    public static layer = LAYERS.WATERMARK;
    public static platform: DeviceType = DeviceType.MOBILE;

    private readonly MENU_BAR_OFFSET_GLOBAL_TIME = new Point(-900, -1620);
    private readonly MENU_BAR_OFFSET_ELAPSED_TIME = new Point(-500, -1620);
    protected GLOBAL_CLOCK_OFFSET = -96;
    protected GLOBAL_CLOCK_INITIAL_OFFSET = -96;

    protected globalTimeClockLabelData: StickyRichLabelData = WaterMarkComponentsConfigLandscape.globalTimeClock;
    protected elapsedTimeClockLabelData: StickyRichLabelData = WaterMarkComponentsConfigLandscape.elapsedTimeClock;
    protected sessionBalanceLabelData: StickyRichLabelData = WaterMarkComponentsConfigLandscape.sessionBalance;
    protected globalTimeClockPureData: StickyRichLabelData = WaterMarkComponentsConfigLandscape.globalTimeClock_pure;
    protected gameNameLabelData: StickyRichLabelData = WaterMarkComponentsConfigLandscape.gameName;
    protected sessionBetsLabelData: StickyRichLabelData = WaterMarkComponentsConfigLandscape.sessionBets;
    protected sessionEarningsLabelData: StickyRichLabelData = WaterMarkComponentsConfigLandscape.sessionEarnings;
    protected maxWinProbabilityLabelData: StickyRichLabelData = WaterMarkComponentsConfigLandscape.maxWinProbability;
    protected RTPWatermarkLabelData: StickyRichLabelData = WaterMarkComponentsConfigLandscape.RTPWatermark;

    protected initGlobalTimeClock(): void {
        super.initGlobalTimeClock();

        this.globalTimeClockPure = this.labels?.addRichLabel(this.globalTimeClockPureData);
        this.globalTimeClockPure?.hide();
    }

    public switchOnGlobalClock(): void {
        super.switchOnGlobalClock();

        this.globalTimeClock?.hide();
        this.globalTimeClockPure?.show();
    }

    public switchOnNetPosition(): void {
        super.switchOnNetPosition();

        if (this.isGlobalClockEnabled) {
            this.globalTimeClockPure?.hide();
            this.globalTimeClock?.show();
        }
    }

    public setMenuBarOffsets(isAddOffset: boolean): void {
        super.setMenuBarOffsets(isAddOffset);

        const screenParams = this.screenManager.getScreenState();

        if (isAddOffset) {
            this.globalTimeClock?.setInitialPosition(this.MENU_BAR_OFFSET_GLOBAL_TIME);
            this.elapsedTimeClock?.setInitialPosition(this.MENU_BAR_OFFSET_ELAPSED_TIME);
            this.globalTimeClock?.setStickyPosition('top-left');
            this.elapsedTimeClock?.setStickyPosition('top-left');
            this.sessionBalance?.setStickyPosition('top-left');
            this.gameNameLabel?.resize(screenParams, true);
            this.globalTimeClock?.resize(screenParams, true);
            this.elapsedTimeClock?.resize(screenParams, true);
            this.sessionBalance?.resize(screenParams, true);
            this.maxWinProbabilityLabel?.hide();
        } else {
            this.labels?.restoreStartPosition();
            this.labels?.restoreInitialStickyPosition();

            if (this.waterMarkViewInitData?.isElapsedTimeEnabled && this.elapsedTimeClock?.initialPosition) {
                this.elapsedTimeClock.sourceContainer.y += this.GLOBAL_CLOCK_INITIAL_OFFSET;
            }

            if (this.waterMarkViewInitData?.isShowMaxWinProbabilityEnabled) {
                this.maxWinProbabilityLabel?.show();
            }

            this.labels?.resize(screenParams, this._isFullscreen);
        }
    }

    public onLandscape(): void {
        super.onLandscape();

        this.setMenuBarOffsets(this.isOffsetAdded);
    }

    protected initMainSprite(): void {
        this.imageSprite = this.objectBuilder.buildSprite(ObjectBuilder.resources.shared_sprite.waterMark_landscape);
        this.container.addChild(this.imageSprite);
    }
}
